export default __webpack_public_path__ + "static/about-us-security1--mobile-e78052d04af3fa7f3f200cf4e6df0b48.jpg";